import React from "react";
import PropTypes from "prop-types";

import "./styles.scss";


const AcceptDevisModal = ({
	setShowAcceptDevisModal,
	showAcceptDevisModal,
	updateDevisState
}) => {

	const handleModal = () => {
		showAcceptDevisModal ? setShowAcceptDevisModal(false) : null;
	};

	const handleAcceptation = () => {
		const waitUpdateState = async () => {
			// update du statut du devis en BDD
			await updateDevisState(1);
		};
		waitUpdateState().then(setShowAcceptDevisModal(false));
	};

	return (
		<>
			<div className="content">
				<p className="title">Confirmation</p>
				<div className="container-modal">
					<p className="subtitle">Acceptez-vous ce devis?</p>
				</div>
				<div className="containerButton">
					<button className="buttonModalPap orange" onClick={handleAcceptation}>Oui, je confirme</button>
					<button className="buttonModalPap white" onClick={handleModal}>Annuler</button>
				</div>
			</div>
			<div className="modalBackground" onClick={handleModal}></div>
		</>
	);
};

AcceptDevisModal.propTypes = {
	setShowAcceptDevisModal: PropTypes.func,
	showAcceptDevisModal: PropTypes.bool,
	updateDevisState: PropTypes.func
};

export default AcceptDevisModal;
